import React, {useEffect, useState, useCallback, useMemo, useRef} from "react";
import PageSerch from "./Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import DoctorListCard from "./Components/DoctorListCard";
import GoogleAd from "./Components/GoogleAd";
import { oneKlicks } from "../../../SDK/oneclick";
import Advertisement from "./Components/Advertisement";
import Paginationnew from "../../../Uitiles/Paginationnew";
import { useLocation } from 'react-router-dom';
import "./SerchDocters.css";
import PageSidebar from "../../../Uitiles/PageSidebar";
import { DoctorCardsSkeleton } from "./Components/DoctorCardSkeleton";


const SerchDocters = () => {
    const locationObj = useLocation(); // React Router location
    // Default location set to Uppal (Hyderabad)
    const [location, setLocation] = useState({ lat: "", lng: "" });
    const [searchLocation, setSearchLocation] = useState(false);
    const [address, setAddress] = useState("");  
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedSpeciality, setSelectedSpeciality] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [listing_type, setListingType] = useState("doctor");
    const [speciality, setSpeciality] = useState("");
    const [hospital, setHospital] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [zip, setZip] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [page_size, setPageSize] = useState(20);
    const [radius, setRadius] = useState(0);
    const [user_id, setUserId] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [doctors, setDoctors] = useState([]);
    const [error, setError] = useState(null);
    const isFetching = useRef(false);
    const fetchTimeout = useRef(null);
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [serchtime, setSerchtime] = useState(0);

    const queryParams = new URLSearchParams(locationObj.search);
    const searchFromUrl = queryParams.get('search');
    const latFromUrlat = queryParams.get('lat');
    const lngFromUrlng = queryParams.get('lng');
    const otherlocationFromUrl = queryParams.get('otherlocation');
    const pageFromUrl = parseInt(queryParams.get('page'), 10);
    const [advertisement, setAdvertisement] = useState([]);


    // Debounce function
    const debounce = (func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    const handleLocationChange = (newLocation) => {
        if (setLocation) {
            setSearchLocation(true);
            setLocation(newLocation);
        }
    };

    // ✅ Extract `page` from URL on mount or when URL changes  
    useEffect(() => {
        const queryParams = new URLSearchParams(locationObj.search);
        const pageFromUrl = parseInt(queryParams.get('page'), 10);
        const searchFromUrl = queryParams.get('search');
        const latFromUrl = queryParams.get('lat');
        const lngFromUrl = queryParams.get('lng');
        const otherlocationFromUrl = queryParams.get('otherlocation');

        if (!isNaN(pageFromUrl)) {
            setPage(pageFromUrl);
        }
        if (searchFromUrl) {
            setSearchTerm(searchFromUrl);
        }
        if (latFromUrl) {
            setLocation({ lat: latFromUrl, lng: lngFromUrl });
        }
        getadvertisement();
    }, [locationObj.search]);

    const getadvertisement = async () => {
        try {
            const tableSchema = '';
            const tableName = 'banners';
            const conditions = {
                banner_type: 'doctor_listing'
            };
            let orderBy = 'id DESC'; // ✅ Changed from RAND() for better performance
            const search = {};
            const pagination = {
                limit: 10 // Limit advertisement results
            };
            const margedata = [];
            const range = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
            setAdvertisement(response.data);
        } catch (err) {
            console.error('Error fetching advertisement:', err);
            setAdvertisement([]);
        }
    }

    const fetchData = useCallback(async () => {
        // Prevent multiple simultaneous calls
        if (isFetching.current) {
            return;
        }

        try {
            isFetching.current = true;
            setIsLoading(true);
            setError(null);
            const starttime = new Date().getTime();

            const allDoctorIds = new Set();
            let uniqueDoctorIds = [];

            // Only search specialities if searchTerm has at least 2 characters
            if(searchTerm && searchTerm.trim().length >= 2){
                const searchTermLowerCase = searchTerm.toLowerCase();
                const tableSchema = '';
                const tableName = 'specialities';
                const conditions = {};
                const orderBy = 'name ASC'; // ✅ Changed from RAND() to name ASC for better performance
                const search = {
                    name: searchTermLowerCase
                };
                const pagination = {
                    limit: 50 // Limit speciality results
                };
                const margedata = [
                    {
                        target_table: 'doctor_specialities',
                        target_column: 'speciality_id',
                        target_value: 'id',
                        target_label: 'doctor_specialities'
                    }
                ];
                const range = [];
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
                
                
                // Extract and deduplicate doctor IDs from the response
                if (response && response.data && Array.isArray(response.data)) {
                    
                    
                    response.data.forEach(speciality => {
                        
                        if (speciality.doctor_specialities && Array.isArray(speciality.doctor_specialities)) {
                            speciality.doctor_specialities.forEach(doctorSpeciality => {
                                if (doctorSpeciality.doctor_id) {
                                    allDoctorIds.add(doctorSpeciality.doctor_id);
                                }
                            });
                        }
                    });
                    
                    // Convert Set to Array for easier use
                    uniqueDoctorIds = Array.from(allDoctorIds);
                }
                setSpeciality(response.data);
            }

            
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'doctor',
                ...(uniqueDoctorIds.length > 0 && {
                    id: uniqueDoctorIds
                }),
            };
            
            // ✅ FIXED: Avoid RAND() - it's very slow! Use proper ordering
            let orderBy = '';
            if (sortBy && sortOrder) {
                orderBy = `${sortBy} ${sortOrder}`;
            } else {
                // Default: Show latest doctors first (much faster than RAND())
                orderBy = 'RAND()';
            }

            // ✅ FIXED: Only include searchTerm if it's not empty
            const search = {};
            if (searchTerm && searchTerm.trim().length >= 2) {
                search.display_name = searchTerm;
            }
            if (uniqueDoctorIds.length > 0) {
                search.id = uniqueDoctorIds;
            }
            const pagination = {
                page: pageFromUrl ? pageFromUrl : page,
                limit: page_size
            };
            
            // Build search fields for speciality and service filtering
            const searchFields = {};
            if (selectedSpeciality) {
                searchFields.speciality_id = selectedSpeciality;
            }
            if (selectedService) {
                searchFields.service_id = selectedService;
            }
            
            // ⚠️ PERFORMANCE NOTE: These joins (margedata) add overhead
            // Consider lazy-loading some of this data if performance is still an issue
            const margedata = [
                {
                    target_table: "doctor_specialities",
                    target_column: "doctor_id",
                    target_value: "id",
                    target_label: "doctor_specialities",
                    "margedata" :[
                        {
                            target_table: "specialities",
                            target_column: "id",
                            target_value: "speciality_id",
                            target_label: "specialities"
                        },
                        {
                            target_table: "services",
                            target_column: "id",
                            target_value: "service_id",
                            target_label: "services"
                        }
                    ],
                    "search_fields": Object.keys(searchFields).length > 0 ? [searchFields] : []
                },
                {
                    target_table: "doctor_experience_education",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "doctor_experience_education"
                },
                {
                    target_table: "appointment_settings",
                    target_column: "doctor_id",
                    target_value: "id",
                    target_label: "appointment_settings"
                },
                {
                    target_table: "doctor_default_location",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "doctor_default_location"
                }
            ];
            const range = {
                // latitude: searchLocation ? location.lat : latFromUrlat ? latFromUrlat : location.lat,
                // longitude: searchLocation ? location.lng : lngFromUrlng ? lngFromUrlng : location.lng,
                // radius: 50, // in kilometers
                // target_latitude: "lat",
                // target_longitude: "lng",
                // table_name: "doctor_default_location",       // join table
                // join_column: "user_id",            // foreign key in user_location
                // base_column: "id"                  // primary key in user
            };
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
            const endtime = new Date().getTime();
            const searchDuration = (endtime - starttime) / 1000; // Convert to seconds
            setSerchtime(searchDuration);
            if (!response || !response.data) {
                throw new Error('Invalid response format from server');
            }

            setTotalPages(response.totalPages);
            setDoctors(response.data);
        } catch (err) {
            console.error('Error fetching doctors:', err);
            setError(err.message || 'Failed to fetch doctors data');
            setDoctors([]);
        } finally {
            setSearchLocation(false);
            setIsLoading(false);
            isFetching.current = false;
        }
    }, [location, searchTerm, page, page_size, selectedSpeciality, selectedService, sortBy, sortOrder]);

    // Memoize the doctors list to prevent unnecessary re-renders
    const memoizedDoctors = useMemo(() => doctors, [doctors]);

    // Initial load
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (fetchTimeout.current) {
            clearTimeout(fetchTimeout.current);
        }
    
        // ✅ Increased debounce time to reduce API calls while typing
        const debounceTime = searchTerm ? 800 : 300; // Longer delay for search text, shorter for filters
        
        fetchTimeout.current = setTimeout(() => {
            // Get existing query params from URL
            const params = new URLSearchParams(window.location.search);
    
            // Update only the params that changed
            if (searchTerm !== undefined) params.set('search', searchTerm);
            if (location?.lat !== undefined) params.set('lat', location.lat);
            if (location?.lng !== undefined) params.set('lng', location.lng);
            if (selectedSpeciality !== undefined) params.set('speciality', selectedSpeciality);
            if (selectedService !== undefined) params.set('service', selectedService);
            if (page !== undefined) params.set('page', page);
    
            // Update the URL without redirecting
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState(null, '', newUrl);
    
            // Fetch data
            fetchData();
        }, debounceTime);
    
        return () => {
            if (fetchTimeout.current) clearTimeout(fetchTimeout.current);
        };
    }, [searchTerm, location, page, selectedSpeciality, selectedService]);
    

    const handleSortChange = (e) => {
        setSortBy(e.target.value);
    };

    const handlesortorder = (e) => {
        setSortOrder(e.target.value);
    };

    const handlePageChange = (pageNumber) => setPage(pageNumber);

    const handleSearch = (searchParams) => {
        const { searchTerm, selectedSpeciality, selectedService, location } = searchParams;
        
        // Update state with search parameters
        if (searchTerm !== undefined) setSearchTerm(searchTerm);
        if (selectedSpeciality !== undefined) setSelectedSpeciality(selectedSpeciality);
        if (selectedService !== undefined) setSelectedService(selectedService);
        if (location) setLocation(location);
        
        // Reset to first page when searching
        setPage(1);
        
        // Trigger search
        setSearchLocation(true);
    };

    return (
        <div>
            <PageSerch location={location} setLocation={handleLocationChange} searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedSpeciality={selectedSpeciality} setSelectedSpeciality={setSelectedSpeciality} selectedService={selectedService} setSelectedService={setSelectedService} onSearch={handleSearch} otherlocation={otherlocationFromUrl}/>
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="dc-haslayout dc-parent-section">
                    <div className="container">
                        <div className="row">
                            <div id="dc-twocolumns" className="dc-twocolumns dc-haslayout d-flex dc-enabled">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 order-first">
                                    {isLoading ? (
                                        <DoctorCardsSkeleton count={6} />
                                    ) : (
                                        <>
                                            <div className="dc-searchresult-holder">
                                                <div className="dc-searchresult-head">
                                                    <div className="dc-title">
                                                        <h4>
                                                            {error ? (
                                                                <span className="text-danger">{error}</span>
                                                            ) : (
                                                                <strong>{memoizedDoctors.length}</strong>
                                                            )}&nbsp;matches found

                                                            <span className="text-danger"> &nbsp; Search time: {serchtime ? `${serchtime.toFixed(2)}s` : '0.00s'}</span>
                                                        </h4>
                                                    </div>
                                                    <div className="dc-rightarea">
                                                        <div className="dc-select">
                                                            <select name="orderby" className="orderby" onChange={handleSortChange} value={sortBy}>
                                                                <option value="">Sort By</option>
                                                                <option value="id">Latest</option>
                                                                <option value="display_name">Name</option>
                                                                <option value="created_at">Registration date</option>
                                                            </select>
                                                        </div>
                                                        <div className="dc-select">
                                                            <select name="order" className="order" onChange={handlesortorder} value={sortOrder}>
                                                                <option value="ASC">Ascending</option>
                                                                <option value="DESC">Descending</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Show 1 banner after every 5 doctors, cycling through the advertisement array */}
                                            {memoizedDoctors.map((doctor, index) => (
                                                <React.Fragment key={doctor.id}>
                                                    <DoctorListCard doctor={doctor} type="doctor" />
                                                    {(index + 1) % 5 === 0 && index !== memoizedDoctors.length - 1 && advertisement.length > 0 && (
                                                        <Advertisement advertisement={advertisement[(Math.floor(index / 5)) % advertisement.length]} />
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            <div id="doctor-results-pages">
                                                <div className="dc-paginationvtwo">
                                                    <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>


                                
                                <div className="col-12 col-md-5 col-lg-4 col-xl-3 order-last">
                                    <PageSidebar/>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default React.memo(SerchDocters);
